module.exports = "/assets/data/c0c292fcc0f35f628b41e3449c8949a6-NG9.data.json";